import AbstractPeriodColumnTemplateSource from "./AbstractPeriodColumnTemplateSource.js";
import ActualsPeriodColumnSource from "../../../reports/columns/periodColumnSource/ActualsPeriodColumnSource.js";

/**
 * This class is used when a period column template should fetch data
 * from the company's accounting data.
 */
export default class ActualsPeriodColumnTemplateSource extends AbstractPeriodColumnTemplateSource {
	isActualsSource() {
		return true;
	}

	_instanceClass() {
		return ActualsPeriodColumnSource;
	}
}
